import styled from 'styled-components';

export const Svg = styled.svg`
  cursor: pointer;
  width: 2em;
`;
